import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USERS_IMPORTER_FEATURE_KEY } from '../keys';
import { UsersImporterState } from '../reducers/users-importer.reducer';

const selectState = createFeatureSelector<UsersImporterState>(USERS_IMPORTER_FEATURE_KEY);

export const selectImporting = createSelector(selectState, (state: UsersImporterState) => state.importing);
export const selectSummary = createSelector(selectState, (state: UsersImporterState) => state.summary);
export const selectDownloadingTemplate = createSelector(selectState, (state: UsersImporterState) => state.downloadingTemplate);
